import React from "react"
import PropTypes from "prop-types"
import styled, { createGlobalStyle, ThemeProvider } from "styled-components"
import { Helmet } from "react-helmet"

import theme from "../../styles/theme"
import media from "../../styles/media"
import { Footer } from "./Footer"
import { Header } from "./Header/Header"

import "../../styles/fonts/StanleyBold-Italic.css"
import "../../styles/fonts/StanleyBold-Regular.css"
import "../../styles/fonts/StanleyPoster-Regular.css"
import "../../styles/fonts/StanleyRegular-Italic.css"
import "../../styles/fonts/StanleyRegular-Regular.css"

const TYPEKIT_URL = "https://use.typekit.net/rja4ndp.css"

const Wrapper = styled.div`
  display: flex;
  min-height: 100vh;
  flex-direction: column;
`

const MainContent = styled.div`
  flex: 1;
  padding-top: ${props => (props.hasHero ? 0 : "90px")};

  ${media.tablet`
    padding-top: ${props => (props.hasHero ? 0 : "260px")};
  `}
`

export function Layout({
  children,
  headerTheme = "light",
  hasHero = false,
  useRosterFiltering = false,
}) {
  const GlobalStyle = createGlobalStyle`

    body {
      margin: 0;
      padding: 0;

      font-family: "neue-haas-grotesk-text", sans-serif;
      font-weight: 400;
      font-style: normal;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    } 
  `

  return (
    <ThemeProvider theme={theme}>
      <Wrapper>
        <Helmet>
          <link defer={false} rel="stylesheet" href={TYPEKIT_URL} />
        </Helmet>

        <GlobalStyle />

        <Header
          dark={headerTheme === "dark"}
          useRosterFiltering={useRosterFiltering}
        />

        <MainContent hasHero={hasHero}>{children}</MainContent>

        <Footer />
      </Wrapper>
    </ThemeProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node,
  headerTheme: PropTypes.oneOf(["dark", "light"]),
  hasHero: PropTypes.bool,
  useRosterFiltering: PropTypes.bool,
}
